<div class="row inventory">
  <div class="col-sm-12">
    <h3>Bestandsverlauf</h3>
    <table class="table whitetable">
      <thead>
        <tr>
          <th>Typ</th>
          <th>Datum</th>
          <th>Benutzer</th>
          <th>Lagerplatz</th>
          <th>Wareneingang</th>
          @if (currentArticle.konsi) {
            <th>Konsi</th>
          }
          <th>Charge</th>
          @if (('material.order.price.check'|HasPerm)) {
            <th class="align-right">Einzelpreis</th>
          }
          <th class="align-right">Menge</th>
          <th>Einheit</th>
          <th>Notiz</th>
        </tr>
      </thead>
      <tbody>
        @for (transaction of list.objects; track transaction) {
          <tr>
            <td>{{transactionTypes[transaction.transaction_type]}}</td>
            <td>{{transaction.date_transferred|date:'dd.MM.yyyy HH:mm'}}</td>
            <td>{{transaction.username}}</td>
            <td>{{transaction.location}}</td>
            <td>{{transaction.date_received|date:'dd.MM.yyyy'}}</td>
            @if (currentArticle.konsi) {
              <td>
                {{transaction.konsi === true ? 'Ja' : transaction.konsi === false ? 'Nein' : ''}}
              </td>
            }
            <td>{{transaction.charge}}</td>
            @if (('material.order.price.check'|HasPerm) && (!!transaction.price)) {
              <td class="align-right">
                {{transaction.price|money:2}}&nbsp;&euro;
              </td>
            }
            @if (('material.order.price.check'|HasPerm) && (!transaction.price)) {
              <td class="align-right">
              </td>
            }
            <td class="align-right" [ngClass]="quantityColor(transaction.amount)">
              {{quantityOperator(transaction.amount)}}&nbsp;{{quantityString(transaction.amount)}}
            </td>
            <td>{{currentVariation.unit}}</td>
            <td>
              {{transaction.note}}
              @if (transaction.bo_id && transaction.bo_index) {
                BA-Nr:&nbsp;{{transaction.bo_id}}-{{transaction.bo_index}}
              }

              @if ((transaction.production_machine_ids?.length ?? 0) > 0) {
                <transaction-machine-list [transaction]="transaction">
                </transaction-machine-list>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <ev-navigation [page]="list.page" [pages]="list.pages" [query]="query()" (goto)="goto($event)"></ev-navigation>
</div>
